import { Practice } from 'ev-types';

// This grabs the list of supported languages
// as set in eAdmin's Edit Customer view.
// The back end serializes this data onto both
// the Customer and Practice in case there's a
// Practice that doens't belong to a Customer.
export function getSupportedLanguagesForPractice(
  practice: Practice | undefined,
): string[] {
  const source = practice?.customer || practice;
  return source?.attributes.available_locales || [];
}
